export default "__VITE_ASSET__446b734f__"